import { httpClient } from '@/utils/httpClient';
import { API_CONFIG } from '@/config/api';
import type {
  EmailSmtpConfig,
  EmailSmtpConfigInput,
  EmailTemplate,
  EmailTemplateUpdateInput,
  OutboundEmail,
} from '@/types/emailAdmin';

const SMTP_ENDPOINT = API_CONFIG.ENDPOINTS.EMAIL_SMTP_CONFIG;
const OUTBOX_ENDPOINT = API_CONFIG.ENDPOINTS.EMAIL_OUTBOX;
const TEMPLATES_ENDPOINT = API_CONFIG.ENDPOINTS.EMAIL_TEMPLATES;

export const emailAdminService = {
  async getSmtpConfig(): Promise<EmailSmtpConfig | null> {
    return httpClient.get<EmailSmtpConfig | null>(SMTP_ENDPOINT);
  },

  async upsertSmtpConfig(input: EmailSmtpConfigInput): Promise<EmailSmtpConfig> {
    if (input.id) {
      return httpClient.patch<EmailSmtpConfig>(SMTP_ENDPOINT, input);
    }

    return httpClient.post<EmailSmtpConfig>(SMTP_ENDPOINT, input);
  },
};

export const emailOutboxService = {
  async list(limit = 50): Promise<OutboundEmail[]> {
    return httpClient.get<OutboundEmail[]>(
      `${OUTBOX_ENDPOINT}?order=created_at.desc&limit=${limit}`,
    );
  },
};

export const emailTemplateService = {
  async list(): Promise<EmailTemplate[]> {
    return httpClient.get<EmailTemplate[]>(TEMPLATES_ENDPOINT);
  },

  async update(input: EmailTemplateUpdateInput): Promise<EmailTemplate> {
    // PostgREST maps JSON keys to the RPC's `p_`-prefixed argument names.
    const payload = {
      p_key: input.key,
      p_locale: input.locale,
      p_version: input.version,
      p_subject_template: input.subject_template,
      p_body_template: input.body_template,
      p_enabled: input.enabled,
    };
    return httpClient.patch<EmailTemplate>(TEMPLATES_ENDPOINT, payload);
  },
};
